var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57009 12.292C9.40009 10.172 12.6201 8.78204 14.2401 8.10204C18.8401 6.17204 19.8001 5.84203 20.4201 5.83203C20.5601 5.83203 20.8601 5.86203 21.0601 6.02203C21.2301 6.16203 21.2701 6.34203 21.3001 6.47203C21.3201 6.60203 21.3501 6.90203 21.3301 7.13203C21.0801 9.77203 20.0001 16.162 19.4501 19.112C19.2201 20.362 18.7601 20.782 18.3201 20.822C17.3601 20.912 16.6301 20.182 15.6901 19.572C14.2301 18.612 13.4101 18.012 11.9901 17.072C10.3501 15.992 11.4101 15.392 12.3501 14.422C12.5901 14.172 16.8401 10.292 16.9201 9.93204C16.9301 9.89204 16.9401 9.72203 16.8401 9.64203C16.7401 9.55203 16.6001 9.58203 16.5001 9.61203C16.3501 9.64203 14.0201 11.192 9.51009 14.262C8.85009 14.722 8.2501 14.942 7.7101 14.932C7.1201 14.922 5.98009 14.592 5.13009 14.322C4.09009 13.982 3.27011 13.802 3.34011 13.222C3.38011 12.922 3.79009 12.612 4.57009 12.302V12.292Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.5997d1bf53a9f2fafcb8bcf18335689d.svg";
export { ForwardRef as ReactComponent };